import { environment } from 'src/environments/environment';

export const originWithContext = () => `${location.origin}${environment.urlContext}`;
